<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">{{pipelineName}}</h1>

                    <a :href="`/#/admin/integrations/runs/manage/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        Back
                    </a>

                    <a v-if="!isDeleted" @click="handleDeleteRunCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa-regular fa-trash-can"></i>
                        Delete
                    </a>

                    <a v-else @click="handlePermanentDeleteRunCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa fa-remove" aria-hidden="true"></i>
                        Permanently delete
                    </a>
                </div>
                <div class="col-lg-4 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div v-for="line in log" :title="line.Message" class="row">
                <div class="col-3">{{line.OccuredAt}}</div>
                <div class="col-9 text-ellipsis">{{line.Message}}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminRunDetailsPage } from '@Integrations/Runs/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    const router = useRouter()
    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        useRunDetailsQuery,
        useDeleteRunCommand,
        usePermanentDeleteRunCommand,
    } = useAdminRunDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelRunDetailsQueryV1, runRunDetailsQueryV1 } = useRunDetailsQuery(tid, id, true)
    const pipelineName = computed(() => modelRunDetailsQueryV1.value?.PipelineName || [])
    const log = computed(() => modelRunDetailsQueryV1.value?.Log || [])
    const isDeleted = computed(() => modelRunDetailsQueryV1.value?.IsDeleted)

    const { invokeDeleteRunCommandV1, succeedDeleteRunCommandV1 } = useDeleteRunCommand(id, tid, userId)
    const { invokePermanentDeleteRunCommandV1, succeedPermanentDeleteRunCommandV1 } = usePermanentDeleteRunCommand(id)

    onMounted(() => {
        runCurrentUserQueryV1()
        runRunDetailsQueryV1()
    })

    watch(succeedDeleteRunCommandV1, () => runRunDetailsQueryV1())

    watch(succeedPermanentDeleteRunCommandV1, (val) => val ? router.push(`/admin/integrations/runs/manage/${tid}`) : null)

    function handleDeleteRunCommandV1() {
        if (confirm(`Do you really want to delete run ${id}?`)) invokeDeleteRunCommandV1()
    }

    function handlePermanentDeleteRunCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete run ${id}?`)) invokePermanentDeleteRunCommandV1()
    }
</script>